import React from 'react';
import BouncingDots from '../components/BouncingDots';

import Styles from '../Loading.module.scss';

const ListItem = ({ text }) => (
  <div className={Styles.ListItem}>
    <div className={Styles.Oval}>{/* <Check /> */}</div>
    {text}
  </div>
);

const Skeleton = () => {
  return (
    <div className={Styles.Loading}>
      <div
        className="d-flex justify-center"
        style={{ margin: '40px 0 16px 0' }}
      >
        <div
          style={{
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            backgroundColor: '#e0e0e0',
          }}
        />
      </div>
      <div className="d-flex flex-column justify-center align-items-center">
        <div>상담으로 연결 중입니다.</div>
        <div>잠시만 기다려 주세요.</div>
      </div>

      <div
        className="d-flex justify-center"
        style={{ margin: '11px 0 27px 0' }}
      >
        <BouncingDots />
      </div>

      <div className={Styles.List}>
        <ListItem />
        <ListItem />
        <ListItem />
      </div>

      <div className={Styles.Footer}>
        <div>이용 중 데이터 요금이 부과 될수 있습니다.</div>
        <div>연결 후 화면에서 선택해주세요.</div>
      </div>
    </div>
  );
};

Skeleton.propTypes = {};

export default Skeleton;
